var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWealthManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_14999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9046 5.22009C20.947 0.926636 27.053 0.926638 28.0954 5.22009C28.7687 7.99361 31.9463 9.30981 34.3836 7.82474C38.1565 5.52584 42.4742 9.8435 40.1753 13.6165C38.6902 16.0537 40.0064 19.2313 42.7799 19.9046C47.0734 20.947 47.0734 27.053 42.7799 28.0954C40.0064 28.7687 38.6902 31.9463 40.1753 34.3836C42.4742 38.1565 38.1565 42.4742 34.3836 40.1753C31.9463 38.6902 28.7687 40.0064 28.0954 42.7799C27.053 47.0734 20.947 47.0734 19.9046 42.7799C19.2313 40.0064 16.0537 38.6902 13.6165 40.1753C9.8435 42.4742 5.52584 38.1565 7.82475 34.3836C9.30981 31.9463 7.99361 28.7687 5.22009 28.0954C0.926638 27.053 0.926636 20.947 5.22009 19.9046C7.99361 19.2313 9.30981 16.0537 7.82474 13.6165C5.52584 9.8435 9.8435 5.52584 13.6165 7.82474C16.0537 9.3098 19.2313 7.99361 19.9046 5.22009Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19.3166C22.0668 19.3166 20.5 20.3607 20.5 21.6499C20.5 22.9391 22.0668 23.9832 24 23.9832C25.9332 23.9832 27.5 25.0274 27.5 26.3166C27.5 27.6057 25.9332 28.6499 24 28.6499M24 19.3166C25.295 19.3166 26.4267 19.7856 27.0322 20.4832M24 19.3166V18.1499M24 28.6499C22.705 28.6499 21.5733 28.1809 20.9678 27.4832M24 28.6499V29.8166",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0866 28.5922C35.6896 27.1363 36 25.5759 36 24C36 20.8174 34.7357 17.7652 32.4853 15.5147C30.2348 13.2643 27.1826 12 24 12C20.8174 12 17.7652 13.2643 15.5147 15.5147C13.2643 17.7652 12 20.8174 12 24C12 25.5759 12.3104 27.1363 12.9134 28.5922C13.5165 30.0481 14.4004 31.371 15.5147 32.4853C16.629 33.5996 17.9519 34.4835 19.4078 35.0866C20.8637 35.6896 22.4241 36 24 36C25.5759 36 27.1363 35.6896 28.5922 35.0866C30.0481 34.4835 31.371 33.5996 32.4853 32.4853C33.5996 31.371 34.4835 30.0481 35.0866 28.5922Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_14999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWealthManagement);
export default __webpack_public_path__ + "static/media/wealthManagement.1f7bfbfabbde67c5d451ebb304593138.svg";
export { ForwardRef as ReactComponent };